import capitalizeImpl from "capitalize";

export function capitalize(s: string, preserve?: boolean) {
    return capitalizeImpl(s, preserve === undefined ? true : preserve);
}
